export default "__VITE_ASSET__gfQPeNqd__"